module.exports = __webpack_public_path__ + "img/组 128.24b297f2.png";